/* eslint-disable */
import axios from "axios";
import config from "./config";
import router from "@/router";
import { Message } from "element-ui";
import { localStorageGet } from "@/utils/localStorageGet";
import store from "@/store";
var baseURL = config.baseURL;
if (config.mock) {
  baseURL = "";
}
const service = axios.create({
  baseURL: baseURL,
  headers: config.headers,
  // withCredentials:true,
  timeout: config.timeout
});
// request拦截器
service.interceptors.request.use(
  options => {
    // console.log(options.status,1,options);
    if (
      window.location.href.slice(window.location.href.length - 5) == "login"
    ) {
      return options;
    }
    let token = localStorageGet("token");
    let tissId = localStorage.loginTissueId
    if (!tissId) {
      Message({ message: "组织超时,请重新登录", type: "error" });
      localStorage.clear()
      localStorage.removeItem('token')
      localStorage.removeItem('userButtonList')//用户菜单按钮权限
      localStorage.removeItem("roleId");
      store.commit("RouterLoad", false);
      store.commit("updateTabList", []);
      store.commit("updateActiveTab", "");
      router.push("/login");
    }
    if (token) {
      options.headers.Token = token;
      options.headers.useTissueId = localStorage.loginTissueId
      // options.headers.Client = localStorageGet("client");
    } else {
      // 重定向到登录页面
      Message({ message: "登录超时,请重新登录", type: "error" });
      localStorage.removeItem("roleId");
      store.commit("RouterLoad", false);
      store.commit("updateTabList", []);
      store.commit("updateActiveTab", "");
      router.push("/login");
    }
    return options;
  },
  error => {
    console.log(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  res => {
    if (res.status == 401 || res.data.code == 30) {
      localStorage.removeItem("token");
      localStorage.removeItem("roleId");
      router.push("/login");
    }
    if (res.data.code === 2) {
      if (store.state.app.online) {
        Message({ message: res.data.msg, type: "error" });
        localStorage.removeItem("token");
        localStorage.removeItem("roleId");
        store.commit("RouterLoad", false);
        store.commit("online", false);
        store.commit("updateTabList", []);
        store.commit("updateActiveTab", "");
        router.push("/login");
      }
    } else if (res.data.msg === "运行时异常") {
      Message({ message: res.data.msg, type: "error" });
    } else {
      let data = res.data;
      return data;
    }
  },
  // eslint-disable-next-line indent
  err => {
    if (err.code === "ECONNABORTED" && err.message.indexOf("timeout") !== -1) {
      Message({ message: "服务器超时,请取消后重新发起", type: "error" });
    } else if (JSON.stringify(err).indexOf("404") > -1) {
      Message({ message: "请求出错!", type: "error" });
    } else if (JSON.stringify(err).indexOf("Network") > -1) {
      Message({
        message: "未能连接服务器请检查网络或其他原因!",
        type: "error"
      });
    }else{
      localStorage.removeItem("token");
      localStorage.removeItem("roleId");
      router.push("/login");
    }
    return Promise.reject(err); // 返回接口返回的错误信息
  }
);
export default service;
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/api/axios.js